export async function updateMenu(menu, document,store)
{
    const formData = {
        document: document,
        menu:menu,
        user_id:store.getters.currentUser.id,
        page:1
    }
    store.commit("menu/setActiveMenu", menu);
    store.commit("menu/setActiveSubMenu", document);
    try{
        const response = await store.dispatch("posts/fetchLists", formData);
        console.log('게시글리스트업', response);

    }catch(error){
        console.log('리스트업 에러', error)
    }
}

export function postLink(post_id,menu,document,store)
{
    if(!store.state.menu.viewPost.some(viewPost=>viewPost === post_id))
    {
        //안본것만 조회수 업데이트
        store.dispatch("posts/updateCount", post_id);
    }
    store.dispatch("menu/setViewPost", post_id);
    
    if( store.getters["posts/getposts"].data && store.getters["posts/getposts"].data.find( (post) => post.id === post_id))
    {
        //console.log('게시글 setView로 만들기',store.getters["posts/getposts"].data.find( (post) => post.id === post_id));
        store.commit("posts/setViewPost", {post:store.getters["posts/getposts"].data.find( (post) => post.id === post_id)});
    }//else{
        const formData={
            //user_id:1,
            user_id:store.getters.currentUser.id,
            post_id:post_id
        }
        store.dispatch("posts/getPost",formData);
    // }   
    
    store.dispatch("posts/getRecommend", {user_id:1, post_id:post_id});   
    store.commit("menu/setActiveMenu", menu );    
    store.commit("menu/setActiveSubMenu", document);   
    //console.log('포스트 링크 메뉴',store.state.menu.activeMenu )  

}

export function morelink(menu,post,ismobile,router) {    
    if(post)
    {
        if(ismobile ==='isMobile')
        {
            router.push({
                path: "/m/community/"+ menu +"/"+ post
            });
        }else{
            router.push({
                path: "/main/community/"+ menu +"/"+ post
            });   
        }
      
    }else{
        if(ismobile ==='isMobile')
        {
            router.push({
                path: "/m/community/" + menu +"/all"
            });
        }else{
            router.push({
                path: "/main/community/" + menu +"/all"
            });    
        }
      
    }  
    
}
